/**
 * Tabbed panels, each containing a product carousel.
 * Implements the WAI-ARIA APG tabs pattern: click or arrow-key/Home/End
 * to move focus and selection between tabs.
 */
class CollectionTabsCarousel extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[data-tab-button]'));
    this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));

    if (this.buttons.length === 0 || this.panels.length === 0) return;

    this.buttons.forEach((btn, i) => {
      btn.addEventListener('click', () => this.activate(i, { focus: false }));
      btn.addEventListener('keydown', (event) => this.onKeydown(event, i));
    });

    const initial = Math.min(
      Math.max(parseInt(this.dataset.initialTab || '0', 10) || 0, 0),
      this.buttons.length - 1
    );
    this.activate(initial, { focus: false });
  }

  activate(index, { focus = true } = {}) {
    this.buttons.forEach((btn, i) => {
      const on = i === index;
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
      btn.tabIndex = on ? 0 : -1;
      if (on && focus) btn.focus();
    });
    this.panels.forEach((panel, i) => {
      panel.hidden = i !== index;
    });
  }

  onKeydown(event, index) {
    const last = this.buttons.length - 1;
    let next = null;

    switch (event.key) {
      case 'ArrowRight':
        next = index === last ? 0 : index + 1;
        break;
      case 'ArrowLeft':
        next = index === 0 ? last : index - 1;
        break;
      case 'Home':
        next = 0;
        break;
      case 'End':
        next = last;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.activate(next);
  }
}

customElements.define('collection-tabs-carousel', CollectionTabsCarousel);
